#!/usr/bin/env node

import '@alinea/cli/bin'
